import SitePropertyData from '@lts-web/data-objects/SitePropertyData';

class SitePropertyUtil {
    static #registry = [];

    static addProperties (propertyList) {
        propertyList.forEach(({ group, propertyKey, propertyValue }) => {
            SitePropertyUtil.addProperty(group, propertyKey, propertyValue);
        });
    }

    static getPropertyValue (group, key) {
        const siteProperty = SitePropertyUtil.getProperty(group, key);

        if (!siteProperty)
            return null;

        return siteProperty.getValue();
    }

    static getProperty (group, key) {
        return SitePropertyUtil.#registry.find(siteProperty => (
            group === siteProperty.getGroup() &&
            key === siteProperty.getKey()
        )) || null;
    }

    static hasProperty (group, key) {
        return SitePropertyUtil.#registry.some(siteProperty => (
            group === siteProperty.getGroup() &&
            key === siteProperty.getKey()
        ));
    }

    static addProperty (group, key, value) {
        if (SitePropertyUtil.hasProperty(group, key)) {
            throw new Error(`The site property '${key}' of group '${group}' already exists`);
        }

        SitePropertyUtil.#registry.push(new SitePropertyData({ group, key, value }));
    }
}

export default SitePropertyUtil;